module.exports = __webpack_public_path__ + "img/s5.42335209.png";